import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Form,
  Col,
  Row,
  Input,
  Divider,
} from 'antd';
import { onError } from 'utils/handlers';
import { CURP_PATTERN, RFC_PATTERN, digitoVerificador } from 'utils/patterns';
import { titleize } from 'utils/normalizers';
import FormSubmitControls from './FormSubmitControls';

const ModalExtraInfoPaymentOrder = ({
  visible,
  setVisible,
  callback,
}) => {
  const [form] = Form.useForm();

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      values.tipo_de_complemento_referencial_id = 1;
      callback(values);
      onCancel();
    } catch (err) {
      onError(err);
    }
  };

  const rules = {
    required: [{ required: true }],
    RFC: [
      {
        pattern: RFC_PATTERN,
        message: 'RFC inválido',
      },
    ],
    CURP: [
      {
        validator: async (rule, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) {
              throw new Error('Ingrese una CURP válida');
            }
          }
        },
      },
    ],
  };

  return (
    <Modal
      open={visible}
      centered
      title={(
        <FormSubmitControls
          label="Información adicional"
          onFinish={onFinish}
          onCancel={onCancel}
        />
      )}
      onCancel={onCancel}
      footer={null}
      closable={false}
      width="80vw"
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={10}>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="nombre_completo_del_notario"
              label="Nombre completo del notario"
              normalize={titleize}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="numero_de_instrumentro_escritura"
              label="Número de instrumento/Expediente"
              rules={rules.required}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="nombre_completo_razon_social"
              label="Nombre completo del ciudadano"
              normalize={titleize}
              rules={rules.required}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="RFC"
              rules={rules.RFC}
              name="rfc"
              normalize={(val) => val.toUpperCase()}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="CURP"
              rules={rules.CURP}
              name="curp"
              normalize={(val) => val.toUpperCase()}
            >
              <Input allowClear />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10}>
          <Col span={24}>
            <Divider orientation="left">Dirección</Divider>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Código postal"
              name="codigo_postal"
            >
              <Input allowClear maxLength={5} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Estado"
              name="entidad_federativa"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Municipio"
              name="municipio"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Localidad"
              name="localidad"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Colonia"
              name="colonia"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Calle"
              name="calle"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Número y letra de dirección"
              name="numero_y_letra_de_direccion"
            >
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Teléfono"
              name="telefono"
            >
              <Input allowClear maxLength={10} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={16}>
            <Form.Item
              label="Observaciones"
              name="observaciones_complemento"
            >
              <Input.TextArea autoSize={{ minRows: 4, maxRows: 4 }} allowClear />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

ModalExtraInfoPaymentOrder.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
};

export default ModalExtraInfoPaymentOrder;
